var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VTextField',{attrs:{"autocomplete":"","outlined":"","label":"Confirmation Code","name":"code"},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }